import React from "react";
import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="footer-background py-3">
      <Container fluid style={{ maxWidth: "1200px" }}>
        <p className="text-center mb-0">
          © Lumu Technologies All rights reserved. |{" "}
          <a
            href="https://lumu.io/legals/"
            className="text-decoration-none legal-link"
            style={{ color: "#ccc" }}
          >
            Legal information
          </a>
          .
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
